import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_CSMS_API_ENDPOINT || 'http://localhost:8080';
const UPI_API_KEY = process.env.REACT_APP_UPI_API_KEY || '8RoAJQlO6YXkDj2TWtSH7MP08LPCqXegxBP10zsc5wzgLr8ALfDLrsAP8LMb2A53IPXkz8iHeJbr8HA0LqootCmfuc1MUS2P2SBHrTLn1XKoylW1R4Qmtskz70hTCyIe';

// Create a separate axios instance for public API calls (no authentication required)
const publicAxios = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

/**
 * Check UPI transaction status by UPI ID
 * @param {string} upiId - The UPI ID to check (e.g., user@paytm)
 * @returns {Promise<Object>} Transaction and payment information
 */
export const checkUPITransactionStatus = async (upiId) => {
  try {
    const url = `/cms/v1/upi/status/${encodeURIComponent(upiId)}`;
    const headers = {
      'x-api-key': UPI_API_KEY,
      'Content-Type': 'application/json',
    };
    
    const response = await publicAxios({
      url,
      method: 'GET',
      headers,
    });

    return response.data;
  } catch (error) {
    console.error('Error checking UPI transaction status:', error);
    
    // Handle different types of errors
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error('Network error: Unable to connect to the server. Please check your internet connection.');
    }
    
    if (error.response?.status === 404) {
      throw new Error('Transaction not found. Please check your UPI ID and try again.');
    }
    
    if (error.response?.status === 401 || error.response?.status === 403) {
      throw new Error('Authentication failed. Please contact support.');
    }
    
    if (error.response?.status === 500) {
      throw new Error('Server error. Please try again later.');
    }
    
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    
    throw new Error(error.message || 'Failed to fetch transaction status. Please try again.');
  }
};

export default {
  checkUPITransactionStatus,
};
